'use client';

import { useEffect, useEffectEvent } from 'react';
import { getBrowserDocument } from '@/lib/utils/browser-window';

export function useDocumentEvent<Type extends keyof DocumentEventMap>(
  type: Type,
  listener: (event: DocumentEventMap[Type]) => void,
  options?: AddEventListenerOptions | boolean,
  enabled = true
): void {
  const invoke = useEffectEvent(listener);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const document_ = getBrowserDocument();
    if (!document_) {
      return;
    }

    const handler = function (this: Document, event: DocumentEventMap[Type]) {
      invoke(event);
    };

    document_.addEventListener(type, handler, options);
    return () => {
      document_.removeEventListener(type, handler, options);
    };
  }, [enabled, options, type]);
}
